module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "faq"
  }, [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('sk-container', [_c('sk-panel', {
    attrs: {
      "transparent": ""
    }
  }, [_c('h1', {
    staticClass: "faq__heading"
  }, [_vm._v(_vm._s(_vm.heading))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.subheading))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1), _vm._v(" "), (!_vm.loading) ? [(_vm.$breakpoints.xs || _vm.$breakpoints.sm) ? _vm._l((_vm.tabs), function(tab, index) {
    return _c('sk-accordian', {
      key: index,
      attrs: {
        "active": _vm.isActive(index, tab.name)
      }
    }, [_c('template', {
      slot: "header"
    }, [_c('h2', {
      staticClass: "faq__cat-title"
    }, [_vm._v(_vm._s(tab.name))])]), _vm._v(" "), _c('template', {
      slot: "content"
    }, [_c('sk-panel', _vm._l((tab.items), function(item, index) {
      return _c('div', {
        key: index
      }, [_c('h3', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
        staticClass: "faq__answer",
        domProps: {
          "innerHTML": _vm._s(item.body)
        }
      })])
    }))], 1)], 2)
  }) : [_c('sk-tabs', [_c('template', {
    slot: "tab-title"
  }, _vm._l((_vm.tabs), function(tab, index) {
    return _c('sk-tab', {
      key: tab.name,
      class: (_vm.activeTab == index ? 'active' : ''),
      attrs: {
        "item": tab.name
      },
      nativeOn: {
        "click": function($event) {
          _vm.activeTab = index
        }
      }
    })
  })), _vm._v(" "), _c('template', {
    slot: "tab-content"
  }, _vm._l((_vm.tabs), function(tab, index) {
    return _c('sk-panel', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.activeTab == index),
        expression: "activeTab == index"
      }],
      key: index
    }, [_c('h2', {
      staticClass: "faq__cat-title"
    }, [_vm._v(_vm._s(tab.name))]), _vm._v(" "), _c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs12": "",
        "sm7": ""
      }
    }, [_vm._l((tab.items), function(item) {
      return [_c('h3', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
        staticClass: "faq__answer",
        domProps: {
          "innerHTML": _vm._s(item.body)
        }
      })]
    }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h2', [_vm._v("Not finding the answer you need?")]), _vm._v(" "), _c('p', [_vm._v("Let us know what problem you are experiencing by giving us your feedback. We look forward to helping you")]), _vm._v(" "), _c('sk-button', {
      staticClass: "faq__btn",
      attrs: {
        "primary": "",
        "router": "",
        "to": {
          name: 'Contact Us'
        }
      }
    }, [_vm._v("Contact us")])], 2)], 1)], 1)
  }))], 2)]] : _vm._e(), _vm._v(" "), _c('sk-signin'), _vm._v(" "), _c('sk-related-movies', {
    attrs: {
      "movies": _vm.related_movies,
      "limit": 6
    }
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e67f39dc","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/faqs/faq.vue
// module id = 519
// module chunks = 0